module.exports = __webpack_public_path__ + "5f305a2642774d8cf1367ec36aeffeb6.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/text.cur
// module id = 609
// module chunks = 0